import {connect} from 'react-redux';
import React, {Component} from 'react';

import * as ObjectUtils from '../../utils/Property';
import {setShowOriginal} from '../../actions/ObjectPage';

const defaultProps = {
    setShowOriginal: isShowOriginal => {
    }
};

class Description extends Component {
    setShowOriginal(event) {
        event.preventDefault();

        this.props.setShowOriginal(!this.props.isShowOriginal);
    }

    getDescription() {
        const {code, translates, isShowOriginal, description} = this.props;
        let response;

        if (translates !== undefined && translates !== null && code !== undefined) {
            if (isShowOriginal) {
                response = description;
            } else {
                response = ObjectUtils.getTranslateByCode(translates, code).description;
            }
        } else if (description !== undefined && description !== null) {
            response = description;
        } else {
            response = '';
        }
        return response;
    }

    render() {
        const {i18n, isShowOriginal, translates} = this.props;

        return (
            <div id="description" className="rent-description">
                <h2>{i18n['objectPage.description']}</h2>
                <p>
                    {this.getDescription()}
                </p>
                {translates !== undefined && translates !== null && <a
                    href=""
                    className="right-circle"
                    onClick={::this.setShowOriginal}
                >
                    {isShowOriginal ? i18n['objectPage.showTranslate'] : i18n['objectPage.showOriginal']}
                </a>}
            </div>
        )
    }
}

Description.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    code: state.languages.currentLanguage.code,
    isShowOriginal: state.objectPage.isShowOriginal,
    translates: state.objectPage.currentObject.meta.translates,
    description: state.objectPage.currentObject.description.description
});

const mapDispatchToProps = {
    setShowOriginal
};

export default connect(mapStateToProps, mapDispatchToProps)(Description);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Description.js